<template>
 <div>
    <div class="mt-5">
     <p><a href="#" @click.prevent="forgotpass = !forgotpass, resendEmailConfirmation = false" class="mt-5">Forgot password ?</a> &nbsp; | &nbsp; <a href="#" @click.prevent="resendEmailConfirmation = !resendEmailConfirmation, forgotpass = false" class="mt-5">Resend Email Confirmation</a></p>
    
      <div class="" v-show="forgotpass">
        <p class="mb-0">Fill in your email address below and we will send you a password reset link via email.</p>
        <div class="login-form-wrapper mt-2">
          <div class="input-wrapper">
            <input type="email" v-model="form.email" name="email" placeholder="Your email"/>
          </div>
        </div>
        <div class="form-group register-action mt-3">
          <button  class="px-4 btn btn-primary btn-rounded" @click.prevent="sendConfirmationLink()">Reset Password</button>
        </div>
       </div>

  </div>
   <div class="mt-0">
     

      <div class="" v-show="resendEmailConfirmation">
        <p class="mb-0">Please write you email, we will re-send account activation link on email.</p>
        <div class="login-form-wrapper mt-2">
          <div class="input-wrapper">
            <input type="email" v-model="resendConfirmation.email" name="email" placeholder="Your email"/>
          </div>
        </div>
        <div class="form-group register-action mt-3">
          <button  class="px-4 btn btn-primary btn-rounded" @click.prevent="resendEmailVerification()">Re-Send Verification Link</button>
        </div>
       </div>

  </div>
 </div>
</template>

<script>
  import Env from '@/env';
  import Helpers from '@/helpers/index';
  import NormalApis from '@/controllers/NormalApis';

  export default {
    name: 'forgotPassForm',
    data() {
      return { 
        forgotpass: false,
        resendEmailConfirmation: false,
        resendConfirmation: {
          email: '',
          app_path: window.location.href,
        },
        form: {
          email: '',
          app_path: window.location.href,
        }
      }
    },
    methods:{
      /**
       * email verification link resend
       */
      resendEmailVerification() {
        this.spinner(true);
        const url = `${Env.baseUrl}/resend-email-verfication`;
        NormalApis.postApi(url, {}, this.resendConfirmation)
        .then(res => {
          this.spinner(false);
          this.$toasted.global.success({
            message: res.data.message
          })
          this.resendConfirmation.email = '';
          this.resendEmailConfirmation = false;
        }).catch(err => {
          this.spinner(false);
          this.$toasted.global.error({
            message: err.response ? err.response.data ? err.response.data.errors[0] : "Fail." : "Please try again later.",
          })
        })
      },

      /**
       * Forgot pass confirmation
       */
      sendConfirmationLink() {
        this.spinner(true);
        const url = `${Env.baseUrl}/forgot-password`;
        NormalApis.postApi(url, {}, this.form)
        .then(res => {
          this.spinner(false);
          this.$toasted.global.success({
            message: res.data.message
          })
          this.form.email = '';
        }).catch(err => {
          this.spinner(false);
          this.$toasted.global.error({
            message: err.response ? err.response.data ? err.response.data.errors[0] : "Fail." : "Please try again later.",
          })
        })
      },
    },

  }
</script>